var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQlSuccessFactors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.189,
    height: 33.14,
    viewBox: "0 0 45.189 33.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.929 33.14H2.258A2.21 2.21 0 0 1 0 30.88V8.285a2.21 2.21 0 0 1 2.258-2.26h40.671a2.211 2.211 0 0 1 2.26 2.26V30.88a2.211 2.211 0 0 1-2.26 2.26zm-12.947-9.685L28.7 24.63l3.092 3.39 5.145-4.156L39 22.2l-1.1-1.36-1.907 1.543-.581.47-3.437 2.779-2-2.177zM13.778 21.9c-2.848 0-8.161 1.4-8.161 4.081v2.04h16.322V25.98c0-2.68-5.313-4.08-8.161-4.08zm0-10.2a4.081 4.081 0 1 0 4.081 4.081 4.086 4.086 0 0 0-4.081-4.081zm16.2 2.464L28.7 15.337l3.092 3.39 5.145-4.156L39 12.906l-1.1-1.359-2.489 2.012c-1.481 1.2-3.437 2.78-3.437 2.78l-2-2.179zM0 5.273V2.26A2.21 2.21 0 0 1 2.258 0h12.353a2.176 2.176 0 0 1 1.581.678l3.841 3.841H2.258A3.889 3.889 0 0 0 0 5.27z",
    transform: "translate(-620.623 -411) translate(620.623 411)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQlSuccessFactors);
export default __webpack_public_path__ + "static/media/ql-success-factors.4db9cc3e4a340a1dde6e76f37d194074.svg";
export { ForwardRef as ReactComponent };